import React from 'react';
import { connect } from 'react-redux';
import MobileAccountNav from "../design/topBar/MobileAccountNav";
import { signinActions } from '../../actions';
import { isNotLogged } from '../ScrollReader/helpers';
import { WhiteLink } from '../design/buttons';

class MobileUserSubmenu extends React.Component {

  render = () => (
    isNotLogged()
    ? <li className="t-pa2">
        <WhiteLink text={this.props.t.sign_in_up} onClick={this.props.onLoginSignUpClick} />
      </li>
    : <MobileAccountNav { ...this.props } />
  )
}

const mapState = (state, ownProps) => ({
  caretImg: `/images/webreader/caret-${state.signin.mobileUserSubmenuOpened ? 'up' : 'down'}.svg`,
  opened: state.signin.mobileUserSubmenuOpened,
  t: I18n.t('components.webreader_header_menu'),
  userImg: state.currentUser.user && state.currentUser.user.thumbnail_url,
  userName: state.currentUser.user && state.currentUser.user.display_name
});

const mapDispatch = (dispatch, ownProps) => ({
  onLoginSignUpClick: () => {
    toggleMobileMenu();
    isNotLogged() && dispatch(signinActions.openModal());
  },
  onToggleClick: () => {
    dispatch(signinActions.toggleMobileUserSubmenu());
  }
});

export default connect(mapState, mapDispatch)(MobileUserSubmenu);
